

const FixedPreview = function(app) {

  const $ = require('jquery');
  const $container = app.$container;

  function setFixedProductView() {
    const $bannerContainer = $('.top-banner-sticky');
    const isStuck = $bannerContainer && $bannerContainer.hasClass('stuck');
    const bannerPixels = isStuck ? $bannerContainer.height() : 0;

    // selectors to keep track of heights and positions
    const $modelContainer = $container.find('.fc-model-container-wrapper');
    const $wrapper = $container.find('.fc-wrapper');

    // amount of pixels to add to the top of the model container
    let topPixels = window.pageYOffset - $wrapper.offset().top + bannerPixels;

    if( topPixels + $modelContainer.height() > $wrapper.height()) {
      return;
    }

    // if the scroll is going up but not beyond the top limit
    if(window.pageYOffset < $modelContainer.offset().top) {
      topPixels = topPixels > 0 ? topPixels + 'px' : '';
      $modelContainer.css('top', topPixels);
    }

    // if the scroll reached the top of the container add the top pixels
    if($wrapper.offset().top < window.pageYOffset) {
      const modelHeight = $modelContainer.height() + $modelContainer.position().top;
      if(modelHeight <= $wrapper.height()) {
        $modelContainer.css('top', topPixels + 'px');
      }
    }
  }

  function init() {
    if(!app.utils.isMobile() && !app.utils.isVerticalTablet()) {
      document.addEventListener('scroll', setFixedProductView);

      $container.find('.fc-accordion-panel-body-revealer').on('transitionend', function() {
        $container.find('.fc-model-container-wrapper').css('top', '');
        setFixedProductView();
      });
    } else {
      document.removeEventListener('scroll', setFixedProductView);
    }
  }


  return {
    init
  };
};

module.exports = FixedPreview;
